<template>
  <div>
    <div v-for="(insurance, insuranceNo) in insurances" :key="insuranceNo">
      <hr />
      <UsWorkerClassificationInsuranceProofFormSection
        :insurance="insurance"
        :form-data="form[insurance.key]"
      />
    </div>
    <div>
      <div class="m-b-10 m-t-30">
        <WdsAlert info icon :title="$t('Data Sharing Notice')">
          <template #description>
            {{
              $t(
                'Please note that by uploading your insurance certificate, you acknowledge and consent to Worksome sharing it with your clients and potential clients for compliance purposes.',
              )
            }}
          </template>
        </WdsAlert>
      </div>
    </div>
    <div class="form-group">
      <div class="col-md-6 col-md-offset-3 text-center" data-vue-app>
        <SubmitButton :text="$t('Save')" auto-submit />
      </div>
    </div>
  </div>
</template>

<script>
import { WdsAlert } from '@worksome/wds-components'
import UsWorkerClassificationInsuranceProofFormSection from './UsWorkerClassificationInsuranceProofFormSection.vue'
import SubmitButton from '@/components/SubmitButton.vue'

export default {
  name: 'UsWorkerClassificationInsuranceProofForm',
  components: {
    UsWorkerClassificationInsuranceProofFormSection,
    SubmitButton,
    WdsAlert,
  },
  props: {
    insurances: {
      type: Object,
      default: () => {},
    },
    complianceInsurances: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    const form = {}
    this.insurances.forEach((insurance) => {
      form[insurance.key] = this.complianceInsurances[insurance.key] || {
        has_insurance: false,
        insurance_policy_limit: null,
        proof_of_insurance_file_ids: null,
        insurance_account_no: null,
      }
    })

    return {
      form,
    }
  },
}
</script>

<style scoped></style>
